import React from 'react';
import styled from 'styled-components';

import { SCREEN } from 'scenes/common/types/screen';

const Image = styled.img`
  height: 5rem;
  width: 100%;
  position: relative;
  z-index: 2;
  top: 37px;

  @media (min-width: ${SCREEN.SMALL}px) {
    height: 238px;
    width: 575px;
    top: 65px;
  }
`;

const ImageStyled = (props: { icon: string }) => {
  const { icon } = props;
  return <Image src={icon} tabIndex={-1} alt="Quote retrieve graphic" />;
};

export default ImageStyled;
